import {call} from "redux-saga-test-plan/matchers";
import {deleteArtist} from "../../../api/artistApi";
import {reloadCommonArtistsAction} from "../../common/commonActions";
import {put, takeLatest, select} from "redux-saga/effects"
import {DELETE_ARTIST} from "../artistActions";
import {emitNotificationAction} from "../../notification/notificationAction";
import {createErrorNotification, createSuccessNotification} from "../../../models/notification";
import i18next from "i18next";
import {selectArtistMap} from "../../common/commonSelector";
import {i18_ARTIST} from "../../../i18nReferences";

function* processDeleteArtist({payload}) {
    const {artistId} = payload
    const artistMap = yield select(state => selectArtistMap(state))
    const name = artistMap[artistId].Kuerzel
    try {
        yield call(deleteArtist, {artistId})
        yield put(emitNotificationAction(createSuccessNotification(i18next.t('EDIT_ARTIST.DELETE_ARTIST_SUCCESS_INFO', {
            ns: i18_ARTIST,
            name
        }), 'deleteArtist')))
        // NOTE: No need to check/update calendar artist selection here.
        // Calendar settings are now URL-based (single source of truth).
        // If the deleted artist was selected, the calendar will detect this
        // on next render and fall back to the logged-in artist automatically.
        yield put(reloadCommonArtistsAction())
    } catch (err) {
        if (err.response.status === 409) {
            yield put(emitNotificationAction(createErrorNotification(i18next.t('EDIT_ARTIST.DELETE_ARTIST_FAILED_FOR_REFERENCES_INFO', {
                ns: i18_ARTIST,
                name
            }), 'deleteArtist')))
            console.log(err.response.data)
        } else {
            yield put(emitNotificationAction(createErrorNotification(i18next.t('EDIT_ARTIST.DELETE_ARTIST_FAILED_INFO', {
                ns: i18_ARTIST,
                name
            }), 'deleteArtist')))
            console.log(err)
        }
    }
}

export function* watchDeleteArtists() {
    yield takeLatest([DELETE_ARTIST], processDeleteArtist)
}
